// TODO VUE3: refactor me to typescript
import { reactive } from 'vue'

let __$waitInstance = null

class Wait {
  constructor() {
    this.list = reactive({})
  }
  waiting(name) {
    return !!this.list[name]
  }
  start(name) {
    return !this.list[name] && (this.list[name] = Date.now())
  }
  end(name) {
    const start = this.list[name]
    delete this.list[name]
    return Date.now() - start
  }
  any() {
    return Object.keys(this.list).length
  }
  clear() {
    const clearList = {}
    Object.keys(this.list).forEach((item) => {
      clearList[item] = this.end(item)
    })
    return clearList
  }
}

export const $wait = new Wait()

export default {
  install: (app) => {
    // Options API
    // Backwards compatibility for methodName: waitFor('waiter-name')
    // TODO VUE3: Ensure __$waitInstance is also instantiated when used in composition API
    app.mixin({
      beforeCreate() {
        __$waitInstance = $wait
      },
    })

    // Options API
    app.config.globalProperties.$wait = $wait
  },
}

export function waitFor(waiter, func) {
  if (typeof func !== 'function') {
    console.warn('[vue-wait] waitFor second argument must be a function')
    return func
  }

  return async function (...args) {
    try {
      if (!__$waitInstance) console.warn('[vue-wait] this.__$waitInstance.start is undefined')
      __$waitInstance?.start(waiter)
      return await func.apply(this, args)
    } finally {
      if (!__$waitInstance) console.warn('[vue-wait] this.__$waitInstance.end is undefined')
      __$waitInstance?.end(waiter)
    }
  }
}
